module.exports = __webpack_public_path__ + "img/wizard.442f4ea3.svg";